import React, { useEffect, useState, useRef } from 'react';
import { useStateValue } from "../../GlobalState/StateProvider";
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataView } from "primereact/dataview";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Toast } from 'primereact/toast';
import axios from "axios";


function BraintreeReports() {
  
    const navigate = useNavigate();
    const [{ user}, dispatch] = useStateValue();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [syncing, setSyncing] = useState(false);
    const toast = useRef(null);
    const [filters, setFilters] = useState({
        'id': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'case_id': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'email': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'active': { value: null, matchMode: FilterMatchMode.EQUALS },
        'BrainTreeStatus': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'subscription_id': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
   
    useEffect(() => {
        callBraintreePastdDueReport() 
    }, []);

    // Add custom CSS to hide filter icons
    useEffect(() => {
        // Add custom style to hide filter icons
        const style = document.createElement('style');
        style.innerHTML = `
            .p-column-filter-row .p-column-filter-menu-button {
                display: none !important;
            }
        `;
        document.head.appendChild(style);
        
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const handleSync = async () => {
        try {
            setSyncing(true);
            const pastDueRecords = data.filter(record => 
                record.BrainTreeStatus === 'PAST_DUE'
            );
            
            if (pastDueRecords.length === 0) {
                toast.current.show({
                    severity: 'info',
                    summary: 'Info',
                    detail: 'No past due records to sync',
                    life: 3000
                });
                return;
            }

            const response = await axios.post('/api/ha/sync', {
                records: pastDueRecords.map(record => ({
                    id: record.id,
                    braintreeStatus: record.BrainTreeStatus
                }))
            });

            if (response.data.status === 'OK') {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response.data.data || 'Records synced successfully',
                    life: 3000
                });
                // Refresh data
                callBraintreePastdDueReport();
            }
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: error.response?.data?.errMsg || 'Failed to sync records',
                life: 3000
            });
        } finally {
            setSyncing(false);
        }
    };

    const caseIdBodyTemplate = (rowData) => {
        return (
            <a 
                href="#" 
                onClick={(e) => {
                    e.preventDefault();
                    navigate(`/CaseDetail/${rowData.case_id}`);
                }}
                className="text-blue-500 hover:text-blue-700 underline"
            >
                {rowData.case_id}
            </a>
        );
    };

    const activeBodyTemplate = (rowData) => {
        return rowData.active ? 'Yes' : 'No';
    };
  
    const callBraintreePastdDueReport = () => {
        setLoading(true);
        
        const url = `api/braintree/subscription/pastdue`;

        const params = {
            user: user.id
        }
        if (user.token !== '' && user.token !== null) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token;
        }
        var endpoint = location.origin + '/' + url;
        axios.post(endpoint, params)
            .then(function (response) {
                //handle success
                if (response.statusText === "OK") {
                    setData(response.data);      
                }
                setLoading(false);
            })
            .catch(function (response) {
                //handle error
                alert(response);
                console.log(response);
                setLoading(false);
            });
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center">
                <div>
                    <h3 className="m-0">Braintree Subscriptions (Not Sync)</h3>
                    <p className="mt-1 text-sm text-gray-500">Total Records: {data.length}</p>
                </div>
                <Button 
                    label="Sync Past Due" 
                    icon="pi pi-sync" 
                    onClick={handleSync}
                    loading={syncing}
                    className="p-button-primary"
                />
            </div>
        );
    };

    const header = renderHeader();

    return (
        <div className="mt-2">
            <Toast ref={toast} />
            <Card>
                <DataTable 
                    value={data} 
                    paginator 
                    rows={25} 
                    rowsPerPageOptions={[25, 50, 100, 150]} 
                    dataKey="id"
                    filters={filters}
                    filterDisplay="row"
                    header={header}
                    emptyMessage="No subscriptions found."
                    responsiveLayout="scroll"
                    loading={loading}
                    loadingIcon="pi pi-spinner"
                >
                    <Column field="id" header="ID" sortable filter filterPlaceholder="Search by ID" showFilterMatchModes={false} />
                    <Column field="case_id" header="Case ID" body={caseIdBodyTemplate} sortable filter filterPlaceholder="Search by Case ID" showFilterMatchModes={false} />
                    <Column field="first_name" header="First Name" sortable filter filterPlaceholder="Search by First Name" showFilterMatchModes={false} />
                    <Column field="last_name" header="Last Name" sortable filter filterPlaceholder="Search by Last Name" showFilterMatchModes={false} />
                    <Column field="email" header="Email" sortable filter filterPlaceholder="Search by Email" showFilterMatchModes={false} />
                    <Column field="subscription_id" header="Subscription ID" sortable filter filterPlaceholder="Search by Subscription ID" showFilterMatchModes={false} />
                    <Column field="BrainTreeStatus" header="BrainTree Status" sortable filter filterPlaceholder="Search by Status" showFilterMatchModes={false} />
                    <Column field="active" header="Active" body={activeBodyTemplate} />
                </DataTable>
            </Card>
        </div>
    );
}
export default BraintreeReports;